import { render, staticRenderFns } from "./SportsCarnival.vue?vue&type=template&id=5d5e8f61&"
import script from "./SportsCarnival.vue?vue&type=script&lang=js&"
export * from "./SportsCarnival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports